
<app-tab-stepper class="stepper" [totalSteps]="totalSteps" [currentStepIndex]="currentStepIndex"></app-tab-stepper>
<ng-content></ng-content>
<!--hr>
<input type="button" value="previous" (click)="previous()">
<input type="button" value="next" (click)="next()">
<hr>
<div>total steps is {{totalSteps}}</div>
<div>current step is {{currentStepIndex}}</div-->